<template>
  <b-card title="GET 7/24 Yapılandırması">
    <b-form-group
      label="Merchant ID (MID)"
      label-for="get724_merchant_id"
    >
      <b-form-input
        id="get724_merchant_id"
        v-model="get724_merchant_id"
        placeholder="Merchant ID (MID)"
      />
    </b-form-group>
    <b-form-group
      label="Müşteri Adı (Kullanıcı Adı, User Name)"
      label-for="get724_user_name"
    >
      <b-form-input
        id="get724_user_name"
        v-model="get724_user_name"
        placeholder="Müşteri Adı (Kullanıcı Adı, User Name)"
      />
    </b-form-group>
    <b-form-group
      label="Provizyon Şifresi (Provaut Password)"
      label-for="get724_provaut_password"
    >
      <b-form-input
        id="get724_provaut_password"
        v-model="get724_provaut_password"
        placeholder="Provizyon Şifresi (Provaut Password)"
      />
    </b-form-group>
    <b-form-group
      label="3D Şifresi (3D Store Key, Merchant Key)"
      label-for="get724_3d_store_key"
    >
      <b-form-input
        id="get724_3d_store_key"
        v-model="get724_3d_store_key"
        placeholder="3D Şifresi (3D Store Key, Merchant Key)"
      />
    </b-form-group>
    <b-form-group
      label="Doğrudan Ödeme Bağlantısı (Api-Classic URL)"
      label-for="get724_api_url"
    >
      <b-form-input
        id="get724_api_url"
        v-model="get724_api_url"
        placeholder="Doğrudan Ödeme Bağlantısı (Api-Classic URL)"
      />
    </b-form-group>
    <b-form-group
      label="3D Bağlantısı (3D, 3DGate URL)"
      label-for="get724_3d_url"
    >
      <b-form-input
        id="get724_3d_url"
        v-model="get724_3d_url"
        placeholder="3D Bağlantısı (3D, 3DGate URL)"
      />
    </b-form-group>
  </b-card>
</template>
<script>
import { BCard, BFormGroup, BFormInput } from 'bootstrap-vue'
import { configField } from '@/views/PosConfigs/Configs/configBind'

export default {
  name: 'Get724',
  components: {
    BCard,
    BFormGroup,
    BFormInput,
  },
  computed: {
    posConfig() {
      return this.$store.getters['posConfigs/getPos_config']
    },
    get724_merchant_id: configField('get724_merchant_id'),
    get724_user_name: configField('get724_user_name'),
    get724_provaut_password: configField('get724_provaut_password'),
    get724_3d_store_key: configField('get724_3d_store_key'),
    get724_api_url: configField('get724_api_url'),
    get724_3d_url: configField('get724_3d_url'),
  },
}
</script>
<style scoped></style>
